export const SPACER_1 = 4;
export const SPACER_2 = SPACER_1 * 2;
export const SPACER_3 = SPACER_1 * 3;
export const SPACER_4 = SPACER_1 * 4;
export const SPACER_5 = SPACER_1 * 5;
export const SPACER_6 = SPACER_1 * 6;
export const SPACER_7 = SPACER_1 * 7;
export const SPACER_8 = SPACER_1 * 8;
export const SPACER_9 = SPACER_1 * 9;
